<div class="ws-flow">
  <div class="ws-flow__glow" aria-hidden="true"></div>
  <div class="ws-flow__grid" aria-hidden="true"></div>

  <header class="ws-flow-nav">
    <a [routerLink]="mktPath.home()" class="ws-flow-nav__brand" [attr.aria-label]="brandWordmark">
      <img class="ws-flow-nav__logo" [src]="brandLogoSrc" [alt]="brandWordmark" width="160" height="36" />
    </a>
    <a [routerLink]="mktPath.home()" class="ws-flow-link">{{ 'website.planSelect.back' | translate }}</a>
  </header>

  <main class="ws-flow-main">
    <header class="ws-flow-hero">
      <ol class="ws-flow-progress" [attr.aria-label]="'website.planSelect.step' | translate">
        <li class="ws-flow-progress__item is-done">
          <span class="ws-flow-progress__dot" aria-hidden="true">1</span>
          <span class="ws-flow-progress__label">{{ 'website.planSelect.progress.claim' | translate }}</span>
        </li>
        <li class="ws-flow-progress__item is-current" aria-current="step">
          <span class="ws-flow-progress__dot" aria-hidden="true">2</span>
          <span class="ws-flow-progress__label">{{ 'website.planSelect.progress.plan' | translate }}</span>
        </li>
        <li class="ws-flow-progress__item">
          <span class="ws-flow-progress__dot" aria-hidden="true">3</span>
          <span class="ws-flow-progress__label">{{ 'website.planSelect.progress.account' | translate }}</span>
        </li>
      </ol>

      <p class="ws-flow-step">{{ 'website.planSelect.step' | translate }}</p>
      <h1 class="ws-flow-title">{{ 'website.planSelect.title' | translate }}</h1>
      <p class="ws-flow-sub">{{ 'website.planSelect.sub' | translate }}</p>

      @if (claimSlug()) {
        <div class="ws-flow-claim" role="status">
          <div class="ws-flow-claim__copy">
            <span class="ws-flow-claim__label">{{ 'website.planSelect.claimLink' | translate }}</span>
            <strong class="ws-flow-claim__url">{{ publicHost }}/{{ claimSlug() }}</strong>
            @if (claimDisplayName()) {
              <span class="ws-flow-claim__name">{{ claimDisplayName() }}</span>
            }
          </div>
          <span class="ws-flow-claim__mark" aria-hidden="true"></span>
        </div>
      }
    </header>

    <div class="ws-plans" role="list">
      @for (plan of plans(); track plan.code) {
        <button
          type="button"
          role="listitem"
          class="ws-plan"
          [class.ws-plan--featured]="plan.featured"
          [class.ws-plan--selected]="selected() === plan.code"
          [class.ws-plan--sales]="plan.salesLed"
          [attr.aria-pressed]="selected() === plan.code"
          (click)="selectPlan(plan.code)"
        >
          <div class="ws-plan__top">
            <h2 class="ws-plan__name">{{ plan.marketingName }}</h2>
            @if (plan.featured) {
              <span class="ws-plan__badge">{{ 'website.plans.recommended' | translate }}</span>
            }
          </div>

          <p class="ws-plan__pitch">{{ 'website.plans.' + plan.code + '.pitch' | translate }}</p>

          <div class="ws-plan__price-block">
            <p class="ws-plan__price">{{ planPrice(plan) }}</p>
            @if (plan.trialDays > 0) {
              <p class="ws-plan__trial">{{
                'website.plans.trialDays' | translate: { days: plan.trialDays }
              }}</p>
            }
            <p class="ws-plan__note">{{ 'website.plans.' + plan.code + '.priceNote' | translate }}</p>
          </div>

          <ul class="ws-plan__features">
            @for (key of planFeatureKeys(plan.code); track key) {
              <li>{{ 'website.plans.' + plan.code + '.features.' + key | translate }}</li>
            }
          </ul>

          @if (selected() === plan.code) {
            <span class="ws-plan__check" aria-hidden="true">
              <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
                <path
                  d="M5 10.5 8.2 13.5 15 6.5"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          }
        </button>
      }
    </div>

    <p class="ws-plan-note">{{ 'website.planSelect.note' | translate: { days: paidTrialDays() } }}</p>
  </main>

  <footer class="ws-flow-bar">
    <div class="ws-flow-bar__inner">
      <div class="ws-flow-bar__meta">
        <span class="ws-flow-bar__label">{{ 'website.planSelect.selectedLabel' | translate }}</span>
        <strong class="ws-flow-bar__value">{{ selectedPlanLabel() }}</strong>
      </div>
      <button
        type="button"
        class="ws-btn ws-btn--lime ws-btn--lg"
        [disabled]="!selected()"
        (click)="continue()"
      >
        {{ ctaLabel() }}
      </button>
    </div>
  </footer>
</div>
